import { styled } from 'styled-components';

export const SubjectPage = styled.div`
  padding: 20px;
  color: #2d3748;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

export const SubjectContainer = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);

  h2 {
    color: #2d3748;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 30px;
  }

  h3 {
    color: #2d3748;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 18px;
  }
`;

export const SubjectSection = styled.div`
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e2e8f0;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

export const SubjectEmpty = styled.div`
  color: #a0aec0;
  font-style: italic;
  padding: 15px;
`;

export const SubjectForm = styled.form`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const SubjectInput = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid #cbd5e0;
  border-radius: 5px;
  font-size: 16px;

  &:disabled {
    background-color: #f7fafc;
    color: #a0aec0;
  }
`;

export const SubjectError = styled.div`
  margin-top: 10px;
  padding: 10px;
  background-color: #fee;
  color: #c53030;
  border-radius: 5px;
  border: 1px solid #fc8181;
`;

export const SubjectStats = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
`;

export const SelectedCount = styled.span`
  color: #9333ea;
  font-weight: 600;
`;

export const GrowCount = styled.span`
  color: #10b981;
  font-weight: 600;
`;

export const StatItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px;
  background-color: #f7fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
`;

export const StatLabel = styled.span`
  font-weight: 600;
  color: #718096;
`;

export const StatValue = styled.span`
  font-weight: 600;
  color: #2d3748;
`;
